export const GRAPH_ROUTES = {
  LIST: '/graphs',
} as const;
